export const CREATE_ORDER = `
mutation createOrder(
    $tenant_id: Int! 
    $input: CreateOrderInput! 
    $lines: [CreateOrderLineInput!]
  ){
    createOrder(
      tenant_id:$tenant_id
      input:$input
      lines:$lines
    ){
      __typename
      ...on Order{
        id
      }
      ...on ResultError{
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_ORDER = `
mutation deleteOrder(
  $id: Int!, 
  $tenant_id: Int!
  $supplier_id: Int
){
deleteOrder(
  id:$id, 
  tenant_id:$tenant_id
  supplier_id:$supplier_id
){
  __typename
  ...on Order{
    id      
  }
  ...on ResultError{
    status_code
    message
    message_translation_key
  }
}
}
`;

export const UPDATE_ORDER = `
mutation updateOrder(
  $tenant_id: Int!
  $input: UpdateOrderInput!
  $supplier_id: Int
){
updateOrder(
  tenant_id:$tenant_id
  input:$input
  supplier_id:$supplier_id
){
  __typename
  ...on Order{
    id
  }
  ...on ResultError{
    status_code
    message
    message_translation_key
  }
}
}
`;

export const UPDATE_ORDER_SHIPMENT_ADDRESS = `mutation updateOrderShipmentAddress (
    $tenant_id: Int!
    $input: UpdateOrderInput!
    $supplier_id: Int
  ){
  updateOrderShipmentAddress (
    tenant_id: $tenant_id
    input: $input
    supplier_id:$supplier_id
  ) {
    __typename
    ...on Order {
      id
    }
    __typename
    ...on ResultError {
      status_code
      message
      message_translation_key
      
    }
  }
}
`;

export const UPDATE_ORDER_TOTAL = `
mutation updateOrderTotal(
  $tenant_id: Int!,
  $input: UpdateTotalInput!
  $supplier_id: Int
){
updateOrderTotal(
  tenant_id:$tenant_id,
  input:$input
    supplier_id:$supplier_id
){
  __typename
  ...on Order{
    id      
  }
  ...on ResultError{
    status_code
    message
    message_translation_key
  }
}
}
`;

export const REJECT_ORDER = `
mutation rejectOrder(
  $tenant_id: Int!
  $input:MultipleActionOnOrdersInput!
  $supplier_id: Int
){
  rejectOrder(
    tenant_id:$tenant_id,
    input:$input
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const CONFIRM_ORDER = `
mutation confirmOrder(
  $tenant_id: Int!
  $input: MultipleActionOnOrdersInput!
  $supplier_id: Int
){
  confirmOrder(
    tenant_id:$tenant_id
    input:$input
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id,
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
export const REGISTER_PAYMENT_ORDER = `
mutation registerPaymentOrder(
  $tenant_id: Int!,
  $input: MultipleActionOnOrdersInput!
  $supplier_id: Int
){
  registerPaymentOrder(
    tenant_id:$tenant_id,
    input:$input
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const CANCEL_ORDER = `
mutation cancelOrder(
  $tenant_id: Int!,
  $input: MultipleActionOnOrdersInput!
  $supplier_id: Int
){
  cancelOrder(
    tenant_id:$tenant_id,
    input:$input
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id      
    }
    ...on ResultError{
      status_code
      message
      message_translation_key      
    }
  }
}
`;

export const SOLICIT_REVISION_OF_ORDER = `
mutation solicitRevisionOfOrder(
  $tenant_id: Int!,
  $input: MultipleActionWithReasonRequiredOnOrdersInput!
  $supplier_id: Int 
){
	solicitRevisionOfOrder(
    tenant_id:$tenant_id,
    input:$input
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const REGISTER_DISPATCH_ORDER = `
mutation registerDispatchOrder(
  $tenant_id: Int!,
  $input: RegisterDispatchInput!
  $supplier_id: Int 
){
  registerDispatchOrder(
    tenant_id:$tenant_id,
    input:$input
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const LABEL_DELIVERED = `
mutation labelDelivered(
  $tenant_id: Int!,
  $input: RegisterDevileryInput!
  $supplier_id: Int
){
  labelDelivered(
    tenant_id: $tenant_id,
    input: $input
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id
      
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const LABEL_RETURNED = `
mutation labelReturned(
  $tenant_id: Int!,
  $input: RegisterDevileryInput!
  $supplier_id: Int
){
  labelReturned(
    tenant_id:$tenant_id,
    input:$input
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id      
    }
    ...on ResultError{
      status_code
      message
      message_translation_key    
    }
  }
}
`;

export const GENERATE_TRACKING_CODE = `
mutation generateTrackingCodeOrder(
  $tenant_id: Int!,
  $input: MultipleActionOnOrdersInput!
  $supplier_id: Int
){
  generateTrackingCodeOrder(
    tenant_id:$tenant_id,
    input:$input
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const GENERATE_TICKET = `
mutation generateTicketOrder(
  $tenant_id: Int!,
  $input: MultipleActionOnOrdersInput!
  $supplier_id: Int
){
  generateTicketOrder(
    tenant_id:$tenant_id,
    input:$input
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const CANCEL_TRACKING_CODE = `
mutation cancelTrackingCodeOrder(
  $tenant_id: Int!,
  $input: MultipleActionOnOrdersInput!
  $supplier_id: Int
){
  cancelTrackingCodeOrder(
    tenant_id:$tenant_id,
    input:$input
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const DELETE_TICKET = `
mutation deleteTicketOrder(
  $tenant_id: Int!,
  $input: MultipleActionOnOrdersInput!
  $supplier_id: Int
){
  deleteTicketOrder(
    tenant_id:$tenant_id,
    input:$input
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const PRINT_TICKET_ORDER = `
mutation printTicketOrder(
  $tenant_id:Int!,
  $input: MultipleActionOnOrdersInput!
  $supplier_id: Int
){
  printTicketOrder(
    tenant_id:$tenant_id,
    input:$input
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id
      pdf
    }
    ...on ResultError{
      status_code
      message
      message_translation_key      
    }  
  }
}
`;

export const REGISTER_ORDER_INCIDENT = `
mutation registerOrderIncident(
  $tenant_id:Int!,
  $input:BasicActionWithReasonRequiredOnOrderInput!
  $supplier_id: Int
){
  registerOrderIncident(
    tenant_id:$tenant_id,
    input:$input
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id      
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const IMPORT_ORDER_PAYMENTS = `
mutation importOrderPayments(
  $input: ImportOrderPaymentsInput!,
  $tenant_id: Int!,
  $file: Upload!
){
  importOrderPayments(
    input:$input,
    tenant_id:$tenant_id,
    file:$file
  ){
    __typename
    ...on OrderPaymentImportResult{
      non_existent_codes
      failed_codes
      excel
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const RESCUE_ORDER = `
mutation rescueOrder(
    $id: Int!,
    $tenant_id: Int!
    $supplier_id: Int     
){
  rescueOrder(
    id:$id,
    tenant_id:$tenant_id
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key      
    }
  }
}
`;

export const CLOSE_REVISION = `
mutation closeRevision (
  $input: BasicActionWithReasonRequiredOnOrderInput!
  $tenant_id: Int!
  $supplier_id: Int 
) {
closeRevision (
  input: $input
  tenant_id: $tenant_id
  supplier_id:$supplier_id
) {
  __typename
  ...on Order {
    id
  }
  ...on  ResultError{
    status_code
    message
    message_translation_key
  }
}
}

`;

export const REQUEST_CANCELLATION = `
mutation requestCancellation (
    $input: BasicActionWithReasonRequiredOnOrderInput!
    $tenant_id: Int!
    $supplier_id: Int  
) {
  requestCancellation (
    input: $input
    tenant_id: $tenant_id
    supplier_id:$supplier_id
  ) {
    __typename
    ...on Order{
      id
    } 
    ...on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const CLOSE_INCIDENT = `
mutation closeIncident (
    $input: BasicActionWithReasonRequiredOnOrderInput!
    $tenant_id: Int!
    $supplier_id: Int 
  ) {
  closeIncident (
    input: $input
    tenant_id: $tenant_id
    supplier_id:$supplier_id
  ) {
    __typename
    ...on Order {
      id
    }
    __typename
    ...on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const PREPARE_ORDER = `
mutation prepareOrder(
  	$tenant_id: Int!,
  	$input: MultipleActionOnOrdersInput!,
  	$supplier_id: Int
){
	prepareOrder(
  	tenant_id: $tenant_id,
  	input:$input,
  	supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id      
    }
    ...on ResultError{
      status_code
      message
      message_translation_key            
    }
  }
}
`;

export const DISPATCH_SCANNED_ORDER = `
mutation dispatchScannedOrder(
  $tenant_id: Int!,
  $tracking_code: String!,
  $supplier_id: Int,
){
  dispatchScannedOrder(
    tenant_id:$tenant_id,
    tracking_code:$tracking_code,
    supplier_id:$supplier_id,
  ){
    __typename
    ...on Order{
      id      
    }
    ...on ResultError{
      status_code
      message
      message_translation_key            
    }
  }
}
`;

export const RETURN_STOCK_ORDER = `
mutation returnStockOrder (
    $tenant_id: Int!
    $input:BasicActionOnOrderInput!
    $supplier_id: Int
  )
  {
  returnStockOrder (
    tenant_id:$tenant_id
    input:$input
    supplier_id:$supplier_id
  ) {
    __typename
    ...on Order {
      id
    } 
    __typename
    ...on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const UPDATE_ORDER_PAYMENT_STATUS = `
mutation updateOrderPaymentStatus(
  $tenant_id: Int!,
  $input: UpdatePaymentStatusInput!,
  $supplier_id: Int
){
  updateOrderPaymentStatus(
    tenant_id:$tenant_id,
    input:$input,
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const UPDATE_ORDER_PAYMENT_TYPE = `
mutation updateOrderPaymentType(
  $tenant_id: Int!,
  $input: UpdatePaymentTypeInput!,
  $supplier_id: Int
){
  updateOrderPaymentType(
    tenant_id:$tenant_id,
    input:$input,
    supplier_id:$supplier_id
  ){
    __typename
    ...on Order{
      id
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
